export default __webpack_public_path__ + "static/media/EXSIGN.513943c2.png";